import type { CustomPillElementProps, FilterPill } from '@/app/common/filters/surfaces/bar/pills/types.ts';
import Pill from '@/app/common/components/Pill';
import type { ResolvedQuickFilter } from '@/app/common/filters/quickFilters/resolveQuickFilters.ts';
import { quickFilterById, quickFilterTargetOf } from '@/app/common/filters/quickFilters/quickFilterCatalogue.ts';
import { chipBehaviourOf } from '@/app/common/filters/types/filterTypeBehaviour.ts';
import { highlightedTracking } from '@/app/common/filters/core/filterTracking.ts';
import {
  RESULT_PAGE_FILTER_TRIGGER_SECTION,
  RESULT_PAGE_FILTER_TYPE,
} from '@/app/common/starTrack/events/resultPageFilter.ts';
import { getQuickFilterIcon } from '@/app/common/filters/surfaces/bar/resultsPills/pillIcons.tsx';

export const QuickFilterPill = ({
  filterPill,
  isLoading,
  busy,
  disabled,
  handleFilterChanged,
}: CustomPillElementProps) => {
  const quickFilter = filterPill?.quickFilterId ? quickFilterById(filterPill.quickFilterId) : undefined;
  const filter = filterPill?.filters[0];

  const target = quickFilter && filter ? quickFilterTargetOf(quickFilter, filter) : undefined;

  if (!quickFilter || !filter || !target) return null;

  const chips = chipBehaviourOf(filter);
  const handleClick = () =>
    chips &&
    handleFilterChanged?.(
      [chips.toggle(filter, target.values)],
      undefined,
      highlightedTracking(RESULT_PAGE_FILTER_TRIGGER_SECTION.RESULT_PAGE, filter, RESULT_PAGE_FILTER_TYPE.POPULAR)
    );

  return (
    <Pill
      isLoading={isLoading}
      busy={busy}
      disabled={disabled}
      label={filterPill.label}
      icon={filterPill.icon}
      handleClick={handleClick}
      hasPopover={false}
      toggles={false}
      selected={false}
      isOpen={false}
      className={`pill pill-quick-${quickFilter.id.toLowerCase()}`}
    />
  );
};

export const createQuickFilterPill = (resolved: ResolvedQuickFilter): FilterPill => {
  const icon = getQuickFilterIcon(resolved.id);

  return {
    id: resolved.groupId,
    key: resolved.id,
    label: resolved.label,
    filters: [resolved.filter],
    quickFilterId: resolved.id,
    ...(icon && { icon }),
    CustomPill: QuickFilterPill,
  };
};
